/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Add_NewInputs */

const vi_customer_add_new = /** @type {(inputs: Customer_Add_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm khách hàng mới`)
};

/**

* @param {Customer_Add_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_add_new = /** @type {((inputs?: Customer_Add_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Add_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_add_new(inputs)
});